import { ThemeProvider } from 'styled-components';
import { GetStaticProps } from 'next';
import Head from 'next/head';
import { NavigationProps } from '@maverick/entity';
import { Allergens } from '@maverick/cms';
import { OutbackTheme } from '@maverick/themes';
import { GetNavigationItems } from '@maverick/sitecore';
import { Config } from 'src/Config';
import { getEmptyNavigationItems, GetFooter, GetHeader, REVALIDATE_DELAY } from 'src/utils/Utils';

interface AllergensPageProps {
    params: {
        items: NavigationProps;
        auth0Config: typeof Config.Auth0;
    };
}

export const getStaticProps: GetStaticProps<AllergensPageProps> = async () => {
    try {
        return {
            props: {
                params: {
                    items: await GetNavigationItems(Config.Brand),
                    auth0Config: Config.Auth0,
                },
            },
            revalidate: REVALIDATE_DELAY,
        };
    } catch (error) {
        return {
            props: {
                params: {
                    items: getEmptyNavigationItems(),
                    auth0Config: Config.Auth0,
                },
            },
            revalidate: REVALIDATE_DELAY,
        };
    }
};

const AllergensPage = (props: AllergensPageProps): React.JSX.Element => {
    const publicUrl = Config.Urls.Cms;
    const { items, auth0Config } = props.params;

    return (
        <ThemeProvider theme={OutbackTheme}>
            <Head>
                <title>Outback Steakhouse - Allergen Information</title>
                <meta
                    name='description'
                    content='View the allergen information for Outback Steakhouse menu items. Find detailed allergen data for every dish on our menu.'
                />
                <link rel='icon' href={`${publicUrl}/favicon.ico`} />
                <link href={`${publicUrl}/css/globals.css`} rel='stylesheet' />
            </Head>
            {GetHeader(items, auth0Config)}
            <Allergens />
            {GetFooter(items)}
        </ThemeProvider>
    );
};

export default AllergensPage;
